import Main from "./Main"

export default function Contact() {
  return <>
    <Main />
  </>
}